import { render, staticRenderFns } from "./uploadDropzone.vue?vue&type=template&id=2597c047&scoped=true"
import script from "./uploadDropzone.vue?vue&type=script&lang=js"
export * from "./uploadDropzone.vue?vue&type=script&lang=js"
import style0 from "./uploadDropzone.vue?vue&type=style&index=0&id=2597c047&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2597c047",
  null
  
)

export default component.exports